import { render, staticRenderFns } from "./RmaInfo.vue?vue&type=template&id=42df5688&"
import script from "./RmaInfo.vue?vue&type=script&lang=js&"
export * from "./RmaInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports